export const PROFILE_SETTINGS_TABS = {
  ALL: 'all',
  JOURNAL: 'journal',
  NODE: 'node',
}
